<template>
  <!-- Site wrapper -->
  <div class="wrapper">
    <cabecalho tituloPagina="Meu Plano" />
    <menuLateral />

    <ContratoModalVerificaCancelamento
      v-if="resumoContrato"
      :resumoContrato="resumoContrato"
      :isVencido="isVencido"
      :modalCancelamento="$refs.contratoModalCancelamento"
      ref="contratoModalVerificaCancelamento"
    />

    <ContratoModalCancelamento
      v-if="resumoContrato"
      :resumoContrato="resumoContrato"
      :isVencido="isVencido"
      @obterResumoContrato="obterResumoContrato"
      ref="contratoModalCancelamento"
    />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <div class="container-fluid"></div>
        <!-- /.container-fluid -->
      </section>
      <!-- Main content -->
      <section class="content">
        <spinnerProcessando
          cssClass="ml-2"
          :status="flagsDeControle.carregandoDados.status"
          :mensagem="flagsDeControle.carregandoDados.mensagem"
        />

        <!-- Aqui é os adicionais -->
        <div  v-if="!flagsDeControle.carregandoDados.status">
          <div v-if="!resumoContrato.pedido_cancelamento">
            <div v-for="(item, index) in this.contratosAdicionaisPedido.filter(contrato => contrato.plano_tipo === 1)" :key="index" class="alert alert-warning alert-dismissible fade show" role="alert">
                  O aditivo <b>{{ item.produto_nome }} </b> permanecerá ativo até o dia <b>{{ item.data_vencimento_por_extenso }}</b>, devido ao cancelamento realizado. Após essa data, você perderá acesso aos recursos vinculados a este aditivo.
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
          </div>

         <!-- Aqui é cancelamento do contrato principal -->
         <div v-if="resumoContrato.pedido_cancelamento && resumoContrato.data_cancelamento == null">
            <div class="alert alert-warning alert-dismissible fade show" role="alert">
              Seu plano atual permanecerá ativo até o dia {{ resumoContrato.data_vencimento_por_extenso }}, devido ao cancelamento realizado. Após essa data, você perderá acesso aos serviços e recursos vinculados a este plano.
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            </div>
         </div>

         <!-- Aqui é quando o contrato esta para ser alterado agendado -->
         <div v-if="!resumoContrato.pode_alterar_plano && resumoContrato.pedido_cancelamento && resumoContrato.data_cancelamento != null">
          <div class="alert alert-warning alert-dismissible fade show" role="alert">
              Você já tem uma solicitação de redução de plano programada para ser processada dia {{ resumoContrato.data_processamento_troca_plano_por_extenso }}. Nova troca de plano poderá somente ser solicitada após essa data.
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
          </div>
         </div>

         <!-- Aqui é quando o contrato só pode ser alterado no vencimento -->
         <div v-if="!resumoContrato.pode_alterar_plano && !resumoContrato.pedido_cancelamento && resumoContrato.data_cancelamento == null">
          <div class="alert alert-warning alert-dismissible fade show" role="alert">
              Você somente poderá alterar seu plano novamente a partir de {{ resumoContrato.data_permitida_troca_de_plano_por_extenso }}.
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
          </div>
         </div>
         <div v-if="temFaturaEmAtrasoDoContratoPrincipal">
          <div class="alert alert-warning alert-dismissible fade show" role="alert">
              O Plano Mirt está atrasado. Para evitar bloqueios ou transtornos futuros, por favor regularize a situação.
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
         </div>
        </div>
        <div class="card border-1" v-if="!flagsDeControle.carregandoDados.status">

          <div class="card-body">
            <UpgradePlano v-if="planoUpgrade && planoGratuitoContratado" :plano="planoUpgrade">
            </UpgradePlano>
            <!-- Conteúdo da guia ativa -->
            <div class="row">
              <div class="col-xl-6 col-12 mt-1">
                <div class="row">
                  <div class="col-6">
                    <span class="texto-cinza">Plano Atual:</span>
                  </div>
                  <div class="col-6 text-right">
                    <span class="texto-escuro">{{ this.resumoContrato.plano_nome }}</span>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-12 mt-2">
                <div class="row">
                  <div class="col-6">
                    <span class="texto-cinza">Mensalidade:</span>
                  </div>
                  <div class="col-6 text-right">
                    <span class="texto-escuro">{{ formatarValorMonetario(this.resumoContrato.valor_total) }}</span>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-12 mt-2">
                <div class="row">
                  <div class="col-6">
                    <span class="texto-cinza">Data Contratação:</span>
                  </div>
                  <div class="col-6 text-right">
                    <span class="texto-escuro">{{ $date(this.resumoContrato.data_contratacao).format('DD/MM/YYYY') }}</span>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-12 mt-2">
                <div class="row">
                  <div class="col-6">
                    <span class="texto-cinza">Próximo vencimento:</span>
                  </div>
                  <div class="col-6 text-right">
                    <span class="texto-escuro">{{ $date(this.resumoContrato.data_vencimento_proximo_mes).format('DD/MM/YYYY') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <ServicosDoPlano :status="flagsDeControle.carregandoDados.status" :trocaDePlano="trocaDePlano" :podeAlterarPlano="podeAlterarPlano" :podeAbortarCancelamento="podeAbortarCancelamento" :resumoContrato="resumoContrato" :pedidoCancelamento="pedidoCancelamento" :resumoContratoPlano="resumoContratoPlano" :abortarCancelamento="abortarCancelamento" />
            <SaldoServicos :status="flagsDeControle.carregandoDados.status" :formatarValorMonetario="formatarValorMonetario" :contratosAdicionaisCredito="contratosAdicionaisCredito" />
            <PlanoAdicionais  :status="flagsDeControle.carregandoDados.status" :valorTotal="valorTotal" :resumoContrato="resumoContrato" :formatarValorMonetario="formatarValorMonetario" :modalVerificaCancelamento="$refs.contratoModalVerificaCancelamento" :contratosAdicionais="contratosAdicionais" />
            <CancelamentoContrato @atualizarDadosResumoContrato="obterResumoContrato()" :pedidoCancelamento="pedidoCancelamento" :resumoContrato="resumoContrato" :modalVerificaCancelamento="$refs.contratoModalVerificaCancelamento" />
          </div>
        </div>
      </section>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
  </div>
  <!-- ./wrapper -->
</template>

<script>
import MeuPlano from './js'
export default MeuPlano
</script>

<style scoped>
@import "./scss/contratos.scss";
</style>
